// /collections/all page customizations
(function() {
  if (window.location.pathname !== '/collections/all') return;

  // Update H1
  var h1 = document.querySelector('.collection-title');
  if (h1) h1.textContent = 'All Products';

  // Update page title
  document.title = 'All Terminus Veil Comics & Products | Clash Studios';

  // Set meta description
  var metaDesc = document.querySelector('meta[name="description"]');
  var desc = 'Every Terminus Veil comic, bundle, and collection — physical and digital. Start your Terminus Veil collection or find the perfect gift. Creator-owned indie comics from Atlanta.';
  if (metaDesc) {
    metaDesc.setAttribute('content', desc);
  } else {
    var m = document.createElement('meta');
    m.name = 'description';
    m.content = desc;
    document.head.appendChild(m);
  }

  // Add description copy below H1
  if (h1) {
    var descDiv = document.createElement('div');
    descDiv.className = 'collection-banner-desc';
    descDiv.textContent = 'Every Terminus Veil comic, bundle, and collection — physical and digital. Start your collection, find the perfect gift, or grab the complete story. All in one place.';
    h1.parentNode.insertBefore(descDiv, h1.nextSibling);
  }
})();
